import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  freightUnavailableOutsideUs: {
    id: 'KynZmG',
    defaultMessage: 'Freight is not available outside of the US',
    description:
      'Explains why switching an order to Freight (LTL) shipping mode is disabled: its ship-to or ship-from country is not the US. Shown under the Parcel/Freight toggle and as the tooltip of the disabled LTL option in the orders grid.',
  },
});
